import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { IconButton, makeStyles, Snackbar } from "@material-ui/core";
import Alert from "@material-ui/lab/Alert";
import CloseIcon from "@material-ui/icons/Close";
import {
  selectNotifcationMessage,
  selectNotificationOpenStatus,
  selectNotificationSeverity,
  setNotificationOpen,
} from "./notificationSlice";

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    '& > * + *': {
      marginTop: theme.spacing(2),
    },
  },
}));

/**
 * Show message of user actions on the UI
 * e.g success of update, delete actions on receipts etc.
 *
 *  */
const Notification = () => {
  const classes = useStyles();
  const open = useSelector(selectNotificationOpenStatus);
  const message = useSelector(selectNotifcationMessage);
  const severity = useSelector(selectNotificationSeverity);
  const dispatch = useDispatch();

  const handleClose = (event: any, reason: any) => {
    dispatch(setNotificationOpen({ open: false, message: "" }));
  };

  const action = (
    <React.Fragment>
      <IconButton
        size="small"
        aria-label="close"
        color="inherit"
        onClick={() =>
          dispatch(setNotificationOpen({ open: false, message: "" }))
        }
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </React.Fragment>
  );

  return (
    <div className={classes.root}>
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        //message={message}
        action={action}

      >
        <Alert severity={severity}>
          {message} 
          </Alert>
      </Snackbar>
    </div>
  );
};
export default Notification;
